export default __webpack_public_path__ + "static/media/assignments.2c873a5b.png";